import React from 'react';
import { Grid } from '@material-ui/core';
import Comments from '../Comments/Comments';
import ReactionAction from './ReactionAction';
import { PostModel, ReactionsType } from '../NewsfeedModels';
import { useNewsfeedContext } from '../NewsfeedContext';

const ExistingPostActionBar = ({ post, commentsExpanded }: { post: PostModel; commentsExpanded?: boolean }) => {
    const { refreshPost } = useNewsfeedContext();

    return (
        <Grid container direction="row" alignItems="center" style={{ padding: 10 }}>
            {(Object.keys(post.reactions) as ReactionsType[]).map((reaction) => (
                <ReactionAction
                    key={reaction}
                    item={post}
                    reactionType={reaction}
                    itemType="post"
                    refresh={() => refreshPost(post)}
                />
            ))}
            <Comments post={post} defaultCommentsExpanded={commentsExpanded ?? false} />
        </Grid>
    );
};

export default ExistingPostActionBar;
